export default __webpack_public_path__ + "static/media/bt-2.1f59db97.jpg";